import api from '@/api.js';
const state = {
    firms: [],
    projects: [],
    timeMonths: [],
    times: [],
    // taskFilter: {},
    billYears: [],
    range: {},
    bills: [],
    billAsPdf: null,
    drives: [],
    currentDrive: null,
    isDriving: false,
    loading: false,
};
const mutations = {
    firms(state, firms) {
        state.firms = firms;
    },
    projects(state, projects) {
        state.projects = projects;
    },
    setTimeMonths(state, months) {
        months.sort((a, b) => (b.year - a.year) || (b.month - a.month));
        state.timeMonths = months;
    },
    setTimes(state, times) {
        state.times = times;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setYears(state, years) {
        state.billYears = years;
    },
    setBills(state, bills) {
        state.bills = bills;
    },
    setRange(state, range) {
        state.range = range;
    },
    createBill(state, bill) {
        state.bills.push(bill); // Ist das OK?
    },
    setBillAsPdf(state, bill) {
        state.billAsPdf = bill;
    },
    setDrives(state, drives) {
        state.drives = drives;
    },
    setCurrentDrive(state, drive) {
        state.currentDrive = drive;
        state.isDriving = !!drive && !drive.endTime;
    },
    addDrive(state, drive) {
        state.drives.unshift(drive);
    },
    updateDrive(state, updated) {
        const i = state.drives.findIndex(d => d.id === updated.id);
        if (i !== -1)
            state.drives.splice(i, 1, updated);
    }
};
const getters = {
    firms: state => state.firms,
    projects: state => state.projects,
    timeMonths: state => state.timeMonths,
    times: state => state.times,
    billYears: state => state.billYears,
    bills: state => state.bills,
    billAsPdf: state => state.billAsPdf
};
const actions = {
    async getFirms({ commit }) {
        const res = await api.worktime.firms();
        commit('firms', res.data);
    },
    async getProjects({ commit }) {
        const res = await api.worktime.projects();
        commit('projects', res.data);
    },
    async getTimeMonths({ commit }) {
        const res = await api.worktime.timeMonths();
        console.log(res.data);
        commit('setTimeMonths', res.data);
        return res.data;
    },
    async getTimes({ commit }, params) {
        const res = await api.worktime.times(params);
        commit('setTimes', res.data && res.data.times);
        return res.data;
    },
    async getTimer({ commit }, timerId) {
        const timer = await api.worktime.getTimer(timerId);
        commit('updateTimer', timer.data);
    },
    async startTimer({ commit }, { taskId, type }) {
        const timer = await api.worktime.startTimer(taskId, { type });
        commit('updateTimer', timer.data);
        console.log('timer started:', timer.data);
        return timer.data;
    },
    async stopTimer({ commit }, timerId) {
        const timer = await api.worktime.stopTimer(timerId);
        commit('updateTimer', timer.data);
    },
    async createBill({ commit }, bill) {
        const res = await api.worktime.createBill(bill);
        const newBill = res.data;
        // Prüfen, ob die neue Rechnung in den aktuellen Range fällt
        const range = state.range;
        let include = true;
        if (range.fromDate && newBill.billDate < range.fromDate)
            include = false;
        if (range.toDate && newBill.billDate > range.toDate)
            include = false;
        if (range.status && !range.status.includes(newBill.status))
            include = false;
        if (include) {
            commit("createBill", newBill);
        }
        return newBill;
    },
    async getBillYears({ commit }) {
        const res = await api.worktime.billYears();
        const years = [...res.data];
        years.sort((a, b) => b.year - a.year);
        commit("setYears", years);
    },
    async getBills({ commit }, range) {
        commit("setRange", range);
        const res = await api.worktime.getBills(range);
        commit("setBills", res.data);
    },
    async getBillAsPdf({ commit }, id) {
        const res = await api.worktime.billAsPdf(id);
        commit("setBillAsPdf", res.data);
    },
    async saveBill({ commit }, id) {
        const res = await api.worktime.saveBill(id);
        return res;
    },
    async loadDrives({ commit }) {
        const res = await api.worktime.drives.list();
        commit('setDrives', res.data);
        const active = res.data.find(d => !d.endTime);
        commit('setCurrentDrive', active || null);
    },
    async startDrive({ commit }, userId) {
        let coords = { latitude: null, longitude: null };
        try {
            const pos = await new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 10000 }));
            console.log('COORDS:', pos);
            coords = pos.coords;
        }
        catch (err) {
            console.warn('GPS Start nicht verfügbar', err);
        }
        const res = await api.worktime.drives.start(userId, coords);
        commit('setCurrentDrive', res.data);
        commit('addDrive', res.data);
    },
    async stopDrive({ commit, state }) {
        if (!state.currentDrive)
            return;
        let coords = { latitude: null, longitude: null };
        try {
            const pos = await new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 10000 }));
            console.log('COORDS:', pos);
            coords = pos.coords;
        }
        catch (err) {
            console.warn('GPS Stop nicht verfügbar', err);
        }
        const res = await api.worktime.drives.stop(state.currentDrive.id, coords);
        commit('updateDrive', res.data);
        commit('setCurrentDrive', null);
    },
    async updateDrive({ commit }, { id, data }) {
        const res = await api.worktime.drives.update(id, data);
        commit('updateDrive', res.data);
    }
};
export const Worktime = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
